import PanelPage from "../../components/panel/panelPage";
import React from "react";
import TasksListWidget from "../../components/widgets/taskListWidget";

const TasksListPage = () => {

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <TasksListWidget />
      </div>
    </PanelPage>
  );
};

export default TasksListPage;
